export const videos = [
  {
    id: "v001",
    title: "庆余年 第二季",
    category: "xiangjiao",
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20atmosphere%2C%20a%20man%20in%20traditional%20robes%20standing%20in%20a%20grand%20hall%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20epic%20film%20poster%20style%2C%20dramatic%20shadows&width=640&height=360&seq=fairy-video-001&orientation=landscape",
    duration: "45分钟",
    quality: "4K",
    views: "1280万",
    rating: 9.2,
    description: "范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣。",
    tags: ["古装", "权谋", "热门"],
    isHot: true,
    isNew: false,
    updateInfo: "更新至36集",
  },
  {
    id: "v002",
    title: "狂飙",
    category: "mitao",
    thumbnail: "https://readdy.ai/api/search-image?query=Dark%20crime%20thriller%20atmosphere%2C%20neon%20city%20night%2C%20two%20men%20in%20suits%20facing%20off%2C%20rainy%20street%2C%20intense%20mood%2C%20film%20noir%20poster%20style&width=640&height=360&seq=fairy-video-002&orientation=landscape",
    duration: "42分钟",
    quality: "4K",
    views: "2560万",
    rating: 9.5,
    description: "讲述了以一线刑警安欣为代表的正义力量，与黑恶势力展开的长达二十年生死较量的故事。",
    tags: ["犯罪", "剧情", "必看"],
    isHot: true,
    isNew: false,
    updateInfo: "全39集",
  },
  {
    id: "v003",
    title: "繁华似锦",
    category: "xigua",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20Shanghai%20cityscape%20at%20sunset%2C%20luxury%20lifestyle%2C%20fashionable%20woman%20in%20designer%20clothes%2C%20elegant%20urban%20drama%20poster%2C%20warm%20golden%20hour%20light&width=640&height=360&seq=fairy-video-003&orientation=landscape",
    duration: "40分钟",
    quality: "1080P",
    views: "890万",
    rating: 8.7,
    description: "讲述了苏沫在职场中从普通员工成长为公司高管，同时收获爱情与友谊的励志故事。",
    tags: ["都市", "职场", "爱情"],
    isHot: false,
    isNew: true,
    updateInfo: "更新至24集",
  },
  {
    id: "v004",
    title: "咒术回战 第二季",
    category: "yinghua",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20action%20scene%2C%20dark%20supernatural%20warrior%20with%20glowing%20energy%2C%20Japanese%20urban%20setting%2C%20dynamic%20battle%20pose%2C%20vibrant%20color%20burst%2C%20anime%20poster%20style&width=640&height=360&seq=fairy-video-004&orientation=landscape",
    duration: "24分钟",
    quality: "4K",
    views: "3200万",
    rating: 9.7,
    description: "怀玉·玉折篇与涩谷事变篇，咒术师与咒灵之间的大规模战斗一触即发。",
    tags: ["动漫", "战斗", "日漫"],
    isHot: true,
    isNew: false,
    updateInfo: "全23集",
  },
  {
    id: "v005",
    title: "欢乐喜剧人 第八季",
    category: "tangdou",
    thumbnail: "https://readdy.ai/api/search-image?query=Comedy%20stage%20show%20with%20bright%20colorful%20lights%2C%20comedian%20performing%20on%20stage%2C%20audience%20laughing%2C%20entertainment%20show%20atmosphere%2C%20warm%20stage%20lighting&width=640&height=360&seq=fairy-video-005&orientation=landscape",
    duration: "90分钟",
    quality: "1080P",
    views: "1560万",
    rating: 8.9,
    description: "各路喜剧大咖集结，用最爆笑的表演为观众带来欢乐，每期精彩不断。",
    tags: ["综艺", "喜剧", "搞笑"],
    isHot: false,
    isNew: true,
    updateInfo: "更新至第8期",
  },
  {
    id: "v006",
    title: "孤注一掷",
    category: "yingtao",
    thumbnail: "https://readdy.ai/api/search-image?query=Intense%20suspense%20thriller%20scene%2C%20dimly%20lit%20room%20with%20computer%20screens%2C%20tense%20atmosphere%2C%20mysterious%20figure%20in%20shadows%2C%20dark%20cinematic%20poster%20style&width=640&height=360&seq=fairy-video-006&orientation=landscape",
    duration: "130分钟",
    quality: "4K",
    views: "5100万",
    rating: 9.1,
    description: "电影取材自上万起真实诈骗案例，揭露境外网络诈骗全产业链的骇人内幕。",
    tags: ["电影", "犯罪", "悬疑"],
    isHot: true,
    isNew: false,
    updateInfo: "HD高清",
  },
  {
    id: "v007",
    title: "小猪佩奇 第九季",
    category: "mogu",
    thumbnail: "https://readdy.ai/api/search-image?query=Cute%20colorful%20children%20cartoon%20scene%2C%20happy%20animal%20family%20in%20sunny%20countryside%2C%20bright%20pastel%20colors%2C%20cheerful%20atmosphere%2C%20kids%20animation%20poster%20style&width=640&height=360&seq=fairy-video-007&orientation=landscape",
    duration: "5分钟",
    quality: "1080P",
    views: "620万",
    rating: 9.4,
    description: "佩奇和乔治与家人朋友们一起，在充满欢笑的日常生活中学习成长。",
    tags: ["动画", "儿童", "亲子"],
    isHot: false,
    isNew: false,
    updateInfo: "全52集",
  },
  {
    id: "v008",
    title: "三体",
    category: "xiangjiao",
    thumbnail: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20scene%2C%20alien%20planet%20with%20three%20suns%2C%20mysterious%20cosmic%20atmosphere%2C%20dramatic%20space%20landscape%2C%20epic%20science%20fiction%20poster%20style&width=640&height=360&seq=fairy-video-008&orientation=landscape",
    duration: "50分钟",
    quality: "4K",
    views: "1890万",
    rating: 9.0,
    description: "纳米科学家汪淼被卷入一场关于外星文明三体人的神秘事件中，人类的命运悬于一线。",
    tags: ["科幻", "悬疑", "热门"],
    isHot: true,
    isNew: false,
    updateInfo: "全30集",
  },
  {
    id: "v009",
    title: "偷偷藏不住",
    category: "mitao",
    thumbnail: "https://readdy.ai/api/search-image?query=Romantic%20youth%20drama%20scene%2C%20young%20couple%20in%20school%20uniform%2C%20cherry%20blossom%20trees%2C%20soft%20pastel%20colors%2C%20sweet%20love%20story%20poster%20style&width=640&height=360&seq=fairy-video-009&orientation=landscape",
    duration: "38分钟",
    quality: "4K",
    views: "2200万",
    rating: 8.8,
    description: "桑稚在高中时期偷偷喜欢哥哥的朋友段嘉许，多年后两人重逢，甜蜜的爱情故事悄然展开。",
    tags: ["爱情", "校园", "甜宠"],
    isHot: true,
    isNew: false,
    updateInfo: "全25集",
  },
  {
    id: "v010",
    title: "漫长的季节",
    category: "xigua",
    thumbnail: "https://readdy.ai/api/search-image?query=Nostalgic%201990s%20Chinese%20town%20in%20autumn%2C%20small%20town%20mystery%2C%20warm%20golden%20light%2C%20quiet%20street%2C%20atmospheric%20drama%20poster%20style&width=640&height=360&seq=fairy-video-010&orientation=landscape",
    duration: "55分钟",
    quality: "4K",
    views: "1680万",
    rating: 9.6,
    description: "一座横跨近20年历史的小城桦林，三个时代交错的故事，揭开一桩陈年悬案的真相。",
    tags: ["悬疑", "剧情", "高分"],
    isHot: false,
    isNew: false,
    updateInfo: "全12集",
  },
  {
    id: "v011",
    title: "火影忍者",
    category: "yinghua",
    thumbnail: "https://readdy.ai/api/search-image?query=Naruto%20anime%20action%20scene%2C%20ninja%20with%20orange%20outfit%2C%20village%20hidden%20in%20leaves%2C%20dynamic%20pose%2C%20bright%20vibrant%20anime%20poster%20style&width=640&height=360&seq=fairy-video-011&orientation=landscape",
    duration: "23分钟",
    quality: "1080P",
    views: "8900万",
    rating: 9.8,
    description: "木叶忍者村的少年漩涡鸣人，以成为火影为目标，踏上充满挑战与成长的忍者之路。",
    tags: ["动漫", "热血", "经典"],
    isHot: false,
    isNew: false,
    updateInfo: "全720集",
  },
  {
    id: "v012",
    title: "爸爸当家 第二季",
    category: "tangdou",
    thumbnail: "https://readdy.ai/api/search-image?query=Heartwarming%20family%20reality%20show%20scene%2C%20father%20and%20children%20playing%20together%2C%20cozy%20home%20setting%2C%20bright%20natural%20light%2C%20warm%20family%20atmosphere&width=640&height=360&seq=fairy-video-012&orientation=landscape",
    duration: "75分钟",
    quality: "1080P",
    views: "430万",
    rating: 8.5,
    description: "明星爸爸们独自带娃的温馨日常，展现父爱的力量与家庭的温暖。",
    tags: ["综艺", "亲子", "温馨"],
    isHot: false,
    isNew: true,
    updateInfo: "更新至第10期",
  },
];